/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetEquipmentSettingQuery } from '../../models/get-equipment-setting-query';
import { GetEquipmentSettingQueryResult } from '../../models/get-equipment-setting-query-result';

export interface ApiEquipmentSettingGetEquipmentSettingsPost$Params {
  
    /**
     * The query parameters for fetching equipment settings.
     */
    body?: GetEquipmentSettingQuery
}

export function apiEquipmentSettingGetEquipmentSettingsPost(http: HttpClient, rootUrl: string, params?: ApiEquipmentSettingGetEquipmentSettingsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetEquipmentSettingQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiEquipmentSettingGetEquipmentSettingsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetEquipmentSettingQueryResult>;
    })
  );
}

apiEquipmentSettingGetEquipmentSettingsPost.PATH = '/api/EquipmentSetting/GetEquipmentSettings';
